import {Component, Inject, Injectable} from '@angular/core';
import {MAT_SNACK_BAR_DATA, MatSnackBar} from '@angular/material/snack-bar';
import {InjectorInstance} from './inject.helper';
import * as Sentry from '@sentry/angular';

@Injectable()
export class NotificationHandler {

  constructor() {
  }

  static handleError(err: any, details?: any): void {
    const {error, errorDetails} = this.processError(details, err);

    Sentry.captureException(err);
    if (details) Sentry.captureException(details);

    InjectorInstance.get<MatSnackBar>(MatSnackBar).openFromComponent(ErrorDetailsComponent, {
      duration: 10000,
      panelClass: 'error',
      data: {
        error,
        details: errorDetails
      }
    });
  }

  static handleWarning(err: any, details?: any, showDetails = true): void {
    const {error, errorDetails} = this.processError(details, err);

    InjectorInstance.get<MatSnackBar>(MatSnackBar).openFromComponent(ErrorDetailsComponent, {
      duration: 10000,
      panelClass: 'warning',
      data: {
        error,
        details: showDetails ? errorDetails : undefined
      }
    });
  }

  private static processError(details: any, err: any) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const errorDetails: string = details
      ? typeof details === 'string'
        ? details
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        : (details.error ? details.error.message : null) || details.message
      : null;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const error: string = err
      ? typeof err === 'string'
        ? err
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        : (err.error ? err.error.message : null) || err.message || err.statusText || err.code || err
      : errorDetails ? errorDetails : $localize`:Notifications|Unknown error message@@notifications-unknown-error-message:Unknown error`;

    console.error(err);
    if (details) {
      console.error(details);
    }
    return {errorDetails, error};
  }

  static notification(message: string): void {
    InjectorInstance.get<MatSnackBar>(MatSnackBar).openFromComponent(NotificationDetailsComponent, {
      duration: 10000,
      data: {
        details: message
      }
    });
  }
}

interface DetailsData {
  error: string;
  details: string;
}

@Component({
  selector: 'snack-bar-notification-details',
  template: `
    <div class="details">{{details}}</div>
  `,
  styles: [`
    .details {
      color: white;
    }
  `],
})
export class NotificationDetailsComponent {

  details: string;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: DetailsData) {
    this.details = data.details;
  }
}

@Component({
  selector: 'snack-bar-error-details',
  template: `
    <div>{{error}}</div>
    <div *ngIf="details" class="small-text details">{{details}}</div>`,
  styles: [`
    .small-text {
      font-size: 75%;
    }

    .details {
      color: white;
    }
  `],
})
export class ErrorDetailsComponent {

  error: string;
  details: string;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: DetailsData) {
    this.error = data.error;
    this.details = data.details;
  }
}
